
<div class="action-container" [class.active]="active">
  <ng-container *ngIf="actionRef">
    <app-game-icon [icon]="actionRef.icon" [specialtySize]="48" [ngxTippy]="tooltip"></app-game-icon>
  </ng-container>

  <ng-template #tooltip>
    <div class="action-name">
      <app-game-icon [icon]="actionRef.icon" [inlineIconSize]="true"></app-game-icon>

      <strong>
        {{ actionRef.name }}
      </strong>
    </div>

    <div class="action-desc">
      {{ actionRef.description }}
    </div>

    <div class="action-cost" *ngIf="actionRef.energyCost > 0">
      <ion-text color="energy">
        <em>
          {{ actionRef.energyCost }} energy
        </em>
      </ion-text>
    </div>
  </ng-template>
</div>
